<template>
	<div class="clearfix rounded pb-5 mx-auto"> <!-- Abdullah chamged here. was clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3-->

        <!-- Abdullah commented this  -->
        <!-- <div class="clearfix row py-2 mb-2 border-bottom">
			<div class="col-sm-6 px-3 company-form-box-title">
				Company Add on Package Access
			</div>
		</div> -->

        <!-- Abdullah added this code here -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">System Settings<span>
            <!-- AbdullahALC chnaged pageurl to api url -->
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / System Settings / Company Add on Package Access</span>
        </h4>

		<div class="row px-3">
			<form enctype="multipart/form-data" @submit.stop.prevent="formSubmit" style="width: 100%;">
            <fieldset :disabled="disabled_by_acl">
				<input type="hidden" v-model="fdata.id" name="id">
				<div id="settings">

					{{successmsg}}

		            <div class="clearfix rounded ibox-content px-0">  <!-- Abdullah added class ibox-content px-0 -->
						<div class="clearfix row no-margin">
							<div class="col-md-12 fixed-section-one px-0 mb-4"> <!-- Abdullah chanded class col-md-6 to col-md-12 removed float-left pl-0 -->
								<div class="clearfix approval-container row bg-white"> <!-- Abdullah changed class company-form-container h-100 -->
									<div class="col-4 approve-level-label">  <!-- Abdullah changed class was justify-content-center py-2 mb-0 border-bottom-->
										<div class="approve-level-title"> <!-- Abdullah changed class was col-sm-12 font-weight-bold cmp-settings-title -->
											Set Company Add on Module Access
										</div>
                                        <!-- Abdullah added this code  -->
                                        <div class="approve-level-description">
                                            Configure add-on module access for the company based on subscription or policy. Enable the required modules and features available for company users. Selected add-on modules will control system availability across the company account.
                                        </div>
									</div>
									<div class="col-8 approve-level-content">  <!-- Abdullah chnaged class here. was col-sm-12 -->
										<table class="table table-sm first-child-no-border">
                                            <thead>
                                                <tr class="align-middle">
                                                    <td class="">Module Name</td>
                                                    <td class="text-right">Status</td>
                                                    <td class="text-right">Last Updated on</td>
                                                </tr>
                                            </thead>
											<tbody>
												<template v-for="(value,key,index)  in company_access_settings">
                                                    <template>
                                                        <tr :key="index" class="align-middle">
                                                            <td class="col-md-3 pl-0 py-2 salary-heads" :class="{'inactive-head' : !value}">
                                                                {{ value.name }}

                                                            </td>

                                                            <!-- Abdullah added this  -->
                                                            <template v-if="index==0">
                                                                <td class="col-md-3 text-right pr-0 py-2">

                                                                    <toggle-button v-model="company_access_settings[key]['value']" :value="true"  :color="{checked: '#01524B', unchecked: '#CC5057', disabled: '#8F8F8F'}"
                                                                        />
                                                                </td>
                                                            </template>

                                                            <!-- Abdullah commented this  -->
                                                            <!-- <td class="col-md-3 text-right pr-0 py-2 icon-off">

                                                                <toggle-button v-model="value.value " :value="true"  :color="{checked: '#01524B', unchecked: '#CC5057', disabled: '#8F8F8F'}"
                                                                    />
                                                            </td> -->

                                                            <!-- Abdullah added this  -->
                                                            <template v-else>
                                                                <td class="col-md-3 text-right pr-0 py-2 icon-off">

                                                                    <toggle-button v-model="company_access_settings[key]['value']" :value="true"  :color="{checked: '#01524B', unchecked: '#CC5057', disabled: '#8F8F8F'}"
                                                                        />
                                                                </td>
                                                            </template>

                                                            <td class="col-md-6 text-right pr-0 py-2"> {{ value.date }}</td>
                                                        </tr>
                                                    </template>
												</template>
											</tbody>
										</table>
                                        <template v-if="!disabled_by_acl">
                                            <div class="btn-wrapper text-center pt-5">  <!-- Abdullah removed class mb-5  -->
                                                <b-button type="submit"  variant="primary">Apply Changes</b-button>
                                            </div>
                                        </template>
									</div>
								</div>
							</div>
						</div>
						<!--<div class="col-sm-12 px-0 text-right"><button type="submit" class="btn btn-primary btn-md">SAVE</button></div>-->
						<!-- this code block append by Faroque -->

					</div>
				</div>
            </fieldset>
			</form>
		</div>
	</div>
</template>
<style scoped>
.dashed_border{border-style: dashed !important;}
</style>
<script>
    export default{
        props: ['companyid', 'flg'],
        mounted() {

            if(this.$acl['company/employee-access-settings/save'] == 2)
                this.disabled_by_acl = false;
            let uri = window.location.href.split('?');
            if (uri.length == 2)
            {
                let vars = uri[1].split('&');
                let getVars = {};
                let tmp = '';
                vars.forEach(function(v){
                    tmp = v.split('=');
                    if(tmp.length == 2)
                        getVars[tmp[0]] = tmp[1];
                });
                //console.log(getVars['#']);
                if(getVars['#']){
                    document.getElementById(getVars['#']).scrollIntoView({ behavior: 'smooth', block: 'end'})
                }
                // do
            }
        },
        data(){
            return {
                company_settings: [],
                intitiate: false,
                fdata: {component_status: '1',component_type: '',field_title: '',field_key:'',is_cash: '',payslip_display: '',system_config: '',taxability: '',rule_type: '',field_type: '',popup_title:'',label_component: '',tax_treatment:'',btn_title:''},
                component_data: [],
                company_id:this.companyid,
                component_statuses: [
                    { value: "1", text: "Enable" },
                    { value: "0", text: "Disable" },
                ],
                tax_types: [
                    { value: "0", text: "Spread Type" },
                    { value: "1", text: "One Off" },
                ],
                tax_treatments: [
                    { value: "1", text: "Allocate tax over fiscal year" },
                    { value: "2", text: "Deduct effective tax up-front" },
                ],
                tt_loader: false,
                v_benefit_noneditable: false,
                successmsg:'',
                errormsg:[],

                go_back : false,
                go_next : false,
                finish : false,
                addons:[],

                barred_chars : ["*","%","!","@","~"],
                show_text_err : false,
                company_access_settings :{},
               // Faroque code ends here
               disabled_by_acl : true,
            }
        },
        methods:{
            // this function added by faroque
            showMessage: function()
            {
                let tmp_flg = 0;
                if(this.fdata.tax_zone != null)
                {
                    if(this.fdata.tax_zone.length > 0)tmp_flg = 1;
                }
                let childdata = {flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg,  move_next:this.go_next , move_back:this.go_back , finish:this.finish};
                this.$emit('childToParent', childdata);
            },
            set_go_back(x){
                this.go_next = false;
                this.go_back = true;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            set_go_next(x){
                this.go_next = true;
                this.go_back = false;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            disable_set_go_next(){
                this.go_next = false;
            },
            setfinish(x){
                this.finish = true;

                this.go_next = false;
                this.go_back = false;

                if(x == 1)
                    this.showMessage();
            },
            // methods goes here..
            saveSettings()
            {
            },
            stringView(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            stringViewReverse(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';

                str = str.replace(/ /g,"_").toLowerCase();

                return str;
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata.component_title = null;
                this.fdata.component_status = '1';
                this.show_text_err = false;
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            scrollToTop() {
                window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
             });

           },
           initiateComponentsStatus()
            {

                for (var c_data in this.company_settings) {
                    if(c_data){
                        for (var cmp_data in this.company_settings[c_data]) {
                            if(this.company_settings[c_data][cmp_data].section_only != 1 && this.company_settings[c_data][cmp_data].system_config != 1 && this.company_settings[c_data][cmp_data].system_config != 2){

                            if(this.company_settings[c_data][cmp_data].field_key != 'tax_calculation_type')
                            this.company_settings[c_data][cmp_data].field_key = (this.company_settings[c_data][cmp_data].status) ? true: false;
                            else
                            this.company_settings[c_data][cmp_data].field_key = this.company_settings[c_data][cmp_data].status;

                            }

                            if(this.company_settings[c_data][cmp_data].child_components){

                              for (var chlcmp_data in this.company_settings[c_data][cmp_data].child_components) {

                              this.company_settings[c_data][cmp_data].child_components[chlcmp_data].field_key = (this.company_settings[c_data][cmp_data].child_components[chlcmp_data].status) ? true: false;

                              }
                            }
                        }
                    }
                }

            },


            getcompany: function()
            {
                axios.get(this.$api_url+'/company/getcompany' , {
                    params: {

                    }
                }).then(function(response){
                    this.company_id = response.data;

                }.bind(this));
            },



            onToggleChange(field_id, event) {                // added event as second arg
              let value = event.value;
              this.component_data[field_id] = value;
             },

             onSelectChange(field_id, field_val) {                // added event as second arg
              this.component_data[field_id] = (field_val == '1')? true:false;
             },

            formSubmit(e)
            {
                e.preventDefault();

                var text = JSON.stringify(this.company_access_settings);
                let formData = new FormData();
                formData.append('access_settings', text);

                formData.append('company_id', this.company_id);
                this.component_data = [];
                let currentObj = this;

                axios.post(this.$api_url + '/company/addon-access-settings', formData)
                    .then(function (response)
                    {
                        this.$bvToast.toast(response.data.message, {title: 'Success',variant: 'success',solid: true});
                        this.get_access_settings();

                    }.bind(this))
                    .catch(function (error)
                    {
                        this.$bvToast.toast(error.response.data.errors.toString(), {title: 'Error!',variant: 'danger',solid: true});
                    });

            },

            get_access_settings: function()
            {
                //
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/addon-access-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;

                    for (const [key, value] of Object.entries(company_access_settings_temp)) {


                            if(value.value==1)
                            {
                                console.log('yes');
                                company_access_settings_temp[key]['value'] = true;
                            }
                            else
                            {
                                console.log('no');

                                company_access_settings_temp[key]['value'] = false;
                            }

                            }

                    this.company_access_settings = company_access_settings_temp;

                }.bind(this));
            },
            getCompanyData:function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/details' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        this.addons =  response.data.module_disabled;


                    }

                }.bind(this));
            },
        },
        created: function(){
           this.getcompany();
           this.getCompanyData();
           this.get_access_settings();


        }
    }
</script>
<style>
.salary_settings .table tbody tr:first-child .icon-off {
	display: revert !important;
}
</style>
